export const Score = {
    "最终成绩":"最终成绩:",
    "原始成绩":"原始成绩:",
    "个人成绩":"个人成绩",
    "占比":"占比",
    "成绩未公布":"成绩未公布",
    "未公布":"未公布",
    "满分":"满分",
    "纸":"纸",
    "分数未公布":"分数未公布",
    "搜索学生名学号":"搜索学生名、学号",
    "修改":"修改",
    "的成绩":"的成绩",
    "满分100":"满分100",
    "确认修改":"确认修改",
    "成绩不允许为空且不能超过100":"成绩不允许为空且不能超过100",
    "成绩组成":"成绩组成",
    "占":"占",
    "的个人成绩":"的个人成绩",
    "请输入成绩":"请输入成绩",
    "设置成绩":"设置成绩",
    "排名":"排名",
    "课程考核标准":"课程考核标准",
    "暂时还没有总成绩记录":"暂时还没有总成绩记录",
    "我是学生":"我是学生",
    "成绩详情":"成绩详情",
    "最高分":"最高分",
    "最低分":"最低分",
    "暂时还没有总成绩":"暂时还没有总成绩",
    "请登录":"请登录",
    "wwwketangpaicom在电脑端设置添加":"www.ketangpai.com，在电脑端设置添加",
    "电脑端在电脑端设置添加":"电脑端，在电脑端设置添加",
}